export default ({
    serviceID: 'default_service',
    templateID: 'mytemplate',
    userID: 'user_Ly2PMsfxkyN9Y0nalmUPk',
});